var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfileSkel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0106 4.90719C11.0106 7.28692 9.10252 9.19508 6.72111 9.19508C4.34051 9.19508 2.43165 7.28692 2.43165 4.90719C2.43165 2.52747 4.34051 0.620117 6.72111 0.620117C9.10252 0.620117 11.0106 2.52747 11.0106 4.90719ZM6.72028 16.825C3.20572 16.825 0.238281 16.2538 0.238281 14.0499C0.238281 11.8452 3.22436 11.2942 6.72028 11.2942C10.2357 11.2942 13.2023 11.8654 13.2023 14.0693C13.2023 16.2741 10.2162 16.825 6.72028 16.825Z",
    fill: "#F74646"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileSkel);
export default __webpack_public_path__ + "static/media/profile_skel.58b9621d2ee3dcdc1f2ae3b81be19caf.svg";
export { ForwardRef as ReactComponent };